import { getImage } from 'gatsby-plugin-image';

export default (nodes) =>
  nodes.map((image, index) => ({
    image: getImage(image),
    name: image.name,
    path: image.relativePath,
    keyId: index,
  }));
